import { render } from "./RegisterInstitutionModal.vue?vue&type=template&id=17bce013"
import script from "./RegisterInstitutionModal.vue?vue&type=script&lang=js"
export * from "./RegisterInstitutionModal.vue?vue&type=script&lang=js"

import "./RegisterInstitutionModal.vue?vue&type=style&index=0&id=17bce013&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__